module.exports = __webpack_public_path__ + "img/cases-brand-herborist-lazyload-101.54f48dcf.jpg";